import React, { createContext, useState, useContext } from "react";

// Create the context
const FilterContext = createContext();

// Create a provider component
export const FilterProvider = ({ children }) => {
    const [filterData, setFilterData] = useState({
        purpose: "",
        propertyType: [],
        district: "",
        town: "",
    });

    const saveFilterData = (data) => {
        setFilterData(data); // Save the filter data in the context
    };

    return (
        <FilterContext.Provider value={{ filterData, saveFilterData }}>
            {children}
        </FilterContext.Provider>
    );
};

// Custom hook to use the context
export const useFilter = () => useContext(FilterContext);
